import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";

export const API_URL = "/api/customer/expectedMonthlyIncome";

interface ExpectedMonthlyIncome {
  expectedMonthlyIncome: string;
  expectedMonthlyIncomeCode: string;
}


const getExpectedMonthlyIncome = async (language: LanTypes, isResident?: boolean) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<ExpectedMonthlyIncome[]>(
    API_URL,
    {
      params: { isResident },
      headers: { langcode: languageCode },
    }
  );
  return response.data;
};

export const useExpectedMonthlyIncome = (isResident?: boolean) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [API_URL, i18n.language],
    queryFn: () => getExpectedMonthlyIncome(i18n.language as LanTypes, isResident),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    enabled: isResident === false || isResident === true,
    staleTime: Infinity,
  });
};
